import { MenuItem } from "@mui/material";
import { TextFieldForm } from "@styleguide";
import { type Control, useWatch } from "react-hook-form";
import { jobSituations } from "../../logics/constants";
import type { IModalActionForm, IModalActionResolver } from "../../logics/types";

export interface IModalActionFormJobSituationProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ModalActionFormJobSituation = ({ control }: IModalActionFormJobSituationProps) => {
  const status = useWatch({ control, name: "status" });

  return (
    <TextFieldForm
      control={control}
      name="jobFollowUp.jobSituation"
      label={`Situation du candidat${status !== "todo" ? " *" : ""}`}
      size="small"
      select
    >
      {jobSituations.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextFieldForm>
  );
};
